/* External dependencies */
import React from 'react';

/* Internal dependencies */
import Fandom from './Fandom';
import MusicLoverRadar from '../assets/images/music-lover-radar-bts-army.png';
import DiscoverScreenshot from '../assets/images/discover-screenshot-bts-army.png';
import MusicScreenshot from '../assets/images/music-screenshot-bts-army.png';
import EventScreenshot from '../assets/images/event-screenshot-bts-army.png';
import WaitlistMember3 from '../assets/images/waitlist-member-3.jpeg';
import WaitlistMember4 from '../assets/images/waitlist-member-4.jpeg';
import WaitlistMember5 from '../assets/images/waitlist-member-5.jpeg';
import WaitlistMember10 from '../assets/images/waitlist-member-10.jpeg';
import SuccessImage from '../assets/images/happy-april-fools-bts.png';

const BTSArmy: React.FC = () => {
  return (
    <Fandom
      fandom="BTS ARMY"
      radarImage={MusicLoverRadar}
      radarTitle="Play BTS. Find love."
      radarButtonText="GET STARTED"
      title="THE BTS ARMY DATING APP"
      headerBackgroundClass="bm-Fandom__header_image--bts-army"
      headerDescription={(
        <>
          <p className="mb-4">Meet fans who love BTS as much as you do</p>
          <p className="text-primary text-underline"><i>It's smooth like butter</i></p>
        </>
      )}
      headerQuote={'"I PURPLE YOU"'}
      headerButtonText="JOIN THE ARMY"
      artistName="BTS"
      firstSectionTitle="Match with the A.R.M.Y"
      firstSectionDescription="You are paired 100% based on music compatibility! No fake BTS fans allowed."
      firstSectionImage={DiscoverScreenshot}
      secondSectionTitle="Discover new music"
      secondSectionDescription="Need some new tunes? Share your favorites songs with other mega fans!"
      secondSectionImage={MusicScreenshot}
      thirdSectionTitle="Never miss a show"
      thirdSectionDescription="Browse upcoming BTS concerts, find out who wants to go, and invite someone for a date!"
      thirdSectionImage={EventScreenshot}
      firstBannerTitle="Permission to love"
      firstBannerDescription="No more singing BTS in your room by yourself. Now you can vibe together with fans in your area."
      firstBannerButtonText="FIND LOVE"
      secondBannerTitle="Love yourself"
      secondBannerDescription="Don't settle for average music taste. Get someone who matches your wavelength!"
      secondBannerButtonText="LEVEL UP"
      playlistId="37i9dQZF1DX08mhnhv6g9b"
      slug="bts-army"
      successImage={SuccessImage}
      productHuntBadge={(
        <a
          href="https://www.producthunt.com/posts/bts-army-dating-app?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-bts&#0045;army&#0045;dating&#0045;app" target="_blank"
        >
            <img
              src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=338805&theme=light" alt="BTS&#0032;Army&#0032;Dating&#0032;App - Meet&#0032;fans&#0032;who&#0032;love&#0032;BTS&#0032;as&#0032;much&#0032;as&#0032;you&#0032;do&#0033; | Product Hunt"
              style={{ width: 225, height: 40 }}
              width={225}
              height={40}
            />
        </a>
      )}
      waitlistImages={[
        WaitlistMember3,
        WaitlistMember4,
        WaitlistMember5,
        WaitlistMember10,
      ]}
    />
  );
};

export default BTSArmy;